import { useContext } from 'react'
import { isNil, not } from 'ramda'
import PropTypes from 'prop-types'
import { Typography } from '@telus-uds/components-web'
import localeContext from '../../../contexts/Locale'
import useTranslate from '../../../hooks/useTranslate'
import { formatCurrency } from '../../../utils/currency'

import {
  DesktopPriceList,
  MobilePriceList,
  StyledPriceInfoContainer,
  StyledTaxesLabel,
  StyledBox
} from './styles'

const PriceInfo = ({ oneTimeSubTotal, firstBillSubTotal, monthlySubTotal, mobileViewPoints }) => {
  const { lang } = useContext(localeContext)
  const translate = useTranslate()
  const StyledPriceInfo = mobileViewPoints ? MobilePriceList : DesktopPriceList

  return (
    <StyledPriceInfoContainer>
      <StyledPriceInfo data-testid="PriceInfo-container">
        <StyledBox>
          <Typography
            variant={{ size: 'small', bold: true }}
            align={mobileViewPoints ? 'center' : 'right'}
          >
            {translate('dueMonthlyLabel')}
          </Typography>
          <Typography
            align={mobileViewPoints ? 'center' : 'right'}
            variant={{
              bold: true,
              size: mobileViewPoints ? 'medium' : 'large'
            }}
            testID="PriceInfo-dueMonthlySubtotal"
          >
            {formatCurrency(monthlySubTotal, lang)}
          </Typography>
        </StyledBox>
        {not(isNil(firstBillSubTotal)) ? (
          <StyledBox>
            <Typography align={mobileViewPoints ? 'center' : 'right'} variant={{ size: 'small' }}>
              {translate('dueFirstBillLabel')}
            </Typography>
            <Typography
              align={mobileViewPoints ? 'center' : 'right'}
              variant={{
                size: mobileViewPoints ? 'medium' : 'large'
              }}
              testID="PriceInfo-dueFirstBillSubtotal"
            >
              {formatCurrency(firstBillSubTotal, lang)}
            </Typography>
          </StyledBox>
        ) : (
          <StyledBox>
            <Typography align={mobileViewPoints ? 'center' : 'right'} variant={{ size: 'small' }}>
              {translate('dueTodayLabel')}
            </Typography>
            <Typography
              align={mobileViewPoints ? 'center' : 'right'}
              variant={mobileViewPoints ? { size: 'medium' } : { size: 'large' }}
              testID="PriceInfo-dueTodaySubtotal"
            >
              {formatCurrency(oneTimeSubTotal, lang)}
            </Typography>
          </StyledBox>
        )}
      </StyledPriceInfo>
      <StyledTaxesLabel data-testid="ApplicableTaxes-container" mobileViewPoints={mobileViewPoints}>
        <Typography variant={{ size: 'small' }}>{translate('plusTaxesLabel')}</Typography>
      </StyledTaxesLabel>
    </StyledPriceInfoContainer>
  )
}

PriceInfo.defaultProps = {
  oneTimeSubTotal: undefined,
  firstBillSubTotal: undefined,
  monthlySubTotal: 0,
  mobileViewPoints: true
}

PriceInfo.propTypes = {
  oneTimeSubTotal: PropTypes.number,
  firstBillSubTotal: PropTypes.number,
  monthlySubTotal: PropTypes.number,
  mobileViewPoints: PropTypes.bool
}
export default PriceInfo
